import React, { createContext, useContext, useState } from 'react';
//interfaces
import { TabsContextProviderProps, TabsContextType } from './interface';

export const TabsContext = createContext({} as TabsContextType);

export function TabsContextProvider(props: TabsContextProviderProps) {
  const { children } = props;

  const [disableTabs, setDisableTabs] = useState(false);

  return (
    <TabsContext.Provider value={{
      disableTabs,
      setDisableTabs
    }}>
      {children}
    </TabsContext.Provider>
  );
}

export const useTabsContext = () => {
  return useContext(TabsContext);
};